var _defs, _path, _polygon, _polygon2, _path2, _path3, _path4, _polygon3, _polygon4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetlife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1045.15 227.86",
    width: 1045.15,
    height: 227.86,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 371.46,135.07 c -2.49,-13.15 -15,-21.74 -28.54,-21.74 -14.68,0 -26.87,7.51 -29.92,21.74 z m -16,92.79 h -23.79 c -40.76,-4.17 -69.92,-29.4 -69.92,-72.66 0,-45.9 32.42,-73.54 78.68,-73.54 49.31,0 77.86,29.52 77.86,76.49 v 5.1 H 312.15 c 0,19.87 10.81,30.61 31.59,30.61 10.8,0 18.56,-3.5 24.1,-12.62 h 48.48 c -7.09,28.66 -32.73,43.52 -60.93,46.62 z",
    id: "path2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "609.47,555.05 584.27,555.05 584.27,514.79 609.47,514.79 609.47,473.45 659.89,473.45 659.89,514.79 684.76,514.79 684.76,555.05 659.89,555.05 659.89,652.49 609.47,652.49 ",
    id: "polygon4",
    transform: "translate(-152.85,-426.42)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "840.53,505.38 890.96,505.38 890.96,652.49 840.53,652.49 ",
    id: "polygon6",
    transform: "translate(-152.85,-426.42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 839.26,225.47 H 788.85 V 132.8 H 763.74 V 92.58 h 25.11 v -7.2 c 0,-19.05 0.55,-33 14.4,-48.31 12.47,-14.23 30.47,-22 49.59,-22 a 46.24,46.24 0 0 1 21.61,4.83 v 42.14 c -5.82,-2.41 -11.08,-4.56 -17.73,-4.56 -13,0 -17.46,7.51 -17.46,23.08 v 12 h 30.12 v 40.26 h -30.12 v 92.67 z",
    id: "path8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 990.2,135.16 c -2.5,-13.15 -15,-21.73 -28.55,-21.73 -14.67,0 -26.87,7.51 -29.91,21.73 z m -15.29,92.7 h -25.33 c -40.34,-4.43 -69.1,-29.6 -69.1,-72.56 0,-45.9 32.42,-73.55 78.68,-73.55 49.32,0 77.85,29.53 77.85,76.5 v 5.1 h -106.1 c 0,19.86 10.8,30.6 31.58,30.6 10.8,0 18.56,-3.49 24.1,-12.62 h 48.49 c -7,28.39 -32.27,43.25 -60.17,46.53 z",
    id: "path10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 712.8,0 c -17.19,0 -31.14,13.5 -31.14,30.16 0,16.66 14,30.15 31.14,30.15 17.14,0 31.13,-13.5 31.13,-30.15 C 743.93,13.51 729.98,0 712.8,0 Z",
    id: "path12"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "278.09,562.79 320.9,459.63 372.42,459.63 402.54,652.64 350.75,652.64 336.22,541.54 335.69,541.54 287.88,652.64 267.26,652.64 221.55,541.54 221.02,541.54 204.38,652.64 152.85,652.64 186.67,459.63 237.67,459.63 ",
    id: "polygon14",
    transform: "translate(-152.85,-426.42)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "821.76,652.34 706.06,652.34 706.06,456.23 758.68,456.23 758.68,609.17 821.76,609.17 ",
    id: "polygon16",
    transform: "translate(-152.85,-426.42)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 1025.81,61.34 h 2.57 c 2.15,0 4.73,0 4.73,-2.5 0,-2.08 -2.15,-2.5 -3.87,-2.5 h -3.43 z m -3,-7.5 h 6.88 c 4.3,0 6,2.09 6,5 0,2.91 -1.72,4.58 -4.73,4.58 l 5.16,7.5 h -3 l -4.73,-7.08 h -2.57 v 7.08 h -3 V 53.84 Z m 6,22.49 c 7.74,0 13.54,-5.62 13.54,-13.74 0,-8.33 -5.8,-13.95 -13.54,-13.95 -8.17,0 -14,5.62 -14,13.95 0,8.12 5.8,13.74 14,13.74 z m 0,-30 a 16.31,16.31 0 0 1 16.34,16.25 c 0,8.95 -7.74,15.83 -16.34,15.83 -9,0 -16.77,-6.88 -16.77,-15.83 0,-9.37 7.75,-16.25 16.77,-16.25 z",
    id: "path18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetlife);
export default __webpack_public_path__ + "static/media/metlife.81ab1b0fe7b8ee48399a21591957b257.svg";
export { ForwardRef as ReactComponent };